module.exports = __webpack_public_path__ + "img/def.b3f4dc93.png";